/**
 * Bugs 3156/3157/3161: decides whether the RTU detail page should replace
 * its content with a full loading/error surface. Extracted as a pure
 * function so it is directly unit-testable without mounting the full page
 * (which owns RTUActions and any open Actions/download dialog - replacing
 * the page unmounts that dialog and destroys its state).
 *
 * The rule: only treat this as an initial/blocking load when there is no
 * usable data yet for the RTU this route is currently asking for. A
 * background Redux/WebSocket refresh for the *same* RTU (loading=true or a
 * transient error, while RTUsdata already matches routeRtuId) must keep
 * rendering the existing content.
 */
export interface RtuDetailPageDataLike {
  id: number | string;
}

export const hasUsableRtuDetailData = (
  routeRtuId: string | null | undefined,
  rtuData: RtuDetailPageDataLike | null | undefined,
): boolean => Boolean(rtuData) && String(rtuData!.id) === String(routeRtuId);

export const shouldShowRtuDetailSkeleton = (params: {
  loading: boolean;
  routeRtuId: string | null | undefined;
  rtuData: RtuDetailPageDataLike | null | undefined;
}): boolean => params.loading && !hasUsableRtuDetailData(params.routeRtuId, params.rtuData);

export const shouldShowRtuDetailError = (params: {
  error: unknown;
  routeRtuId: string | null | undefined;
  rtuData: RtuDetailPageDataLike | null | undefined;
}): boolean => Boolean(params.error) && !hasUsableRtuDetailData(params.routeRtuId, params.rtuData);
